/**
 * EDD mapper — 문서 인스턴스 값 → [[변수]] payload.
 * 승인 체크박스는 if-wrap 불리언 (edd_approved / edd_not_approved).
 */
export interface EddDocInput {
  values: Record<string, string>;
  checkbox: string;
}

export function buildEddVariables(doc: EddDocInput): Record<string, any> {
  const out: Record<string, any> = { ...(doc.values || {}) };
  if (doc.checkbox) out[doc.checkbox] = true;
  return out;
}
